import React, { Component } from "react";
import * as Icon from "react-feather";

import UtilityService from "../../../../services/UtilityService";

import ChecksList from "./ChecksList";

import ToolsCollapsiblePanel from "../kit/ToolsCollapsiblePanel";
import ToolsNotice from "../kit/ToolsNotice";

import "./journal-proof-panel.css";

class JournalProofPanel extends Component {
	renderHeadline = () => {
		const { proof } = this.props;
		const failingRows = proof.filter(row => !row.passed);
		const isEverythingTied = failingRows.length === 0;

		const title = isEverythingTied
			? `Everything ties — ${proof.length} of ${proof.length}`
			: `${failingRows.length} of ${proof.length} do not tie: ${failingRows.map(row => row.label.toLowerCase()).join(", ")}`;

		return (
			<ToolsNotice
				tone={isEverythingTied ? "success" : "warning"}
				icon={isEverythingTied ? <Icon.CheckCircle size={18} /> : <Icon.AlertTriangle size={18} />}
				title={title}
				detail="Each figure is added up from this journal's own lines and compared with what the Jane reports state, so a line put in the wrong place shows here rather than in QuickBooks."
			/>
		);
	};

	renderLocationTable = () => {
		const { revenueTable, proof, siteAttribute } = this.props;
		const formatMoney = amount => UtilityService.formatMoney({ value: amount, emptyText: "—" });

		if (!revenueTable || revenueTable.rows.length === 0) {
			return null;
		}

		const isCheckedBySite = proof.some(row => row.key === "revenueByLocation");
		const tableNote = isCheckedBySite
			? `Net of tax. Each site is a QuickBooks ${siteAttribute}; each column, with its tax, is checked against the Billing Summary in the proof below.`
			: "Net of tax. This client's journal does not record the site, so all revenue sits in one column.";

		return (
			<div className="journal-proof__table-wrap">
				<table className="journal-proof__table">
					<thead>
						<tr>
							<th className="journal-proof__account">Revenue account</th>
							{revenueTable.locations.map(location => (
								<th key={location.key} className="journal-proof__amount">
									{location.name}
								</th>
							))}
							<th className="journal-proof__amount">Total</th>
						</tr>
					</thead>
					<tbody>
						{revenueTable.rows.map(row => (
							<tr key={row.accountId}>
								<td className="journal-proof__account">{row.accountName}</td>
								{revenueTable.locations.map(location => (
									<td key={location.key} className="journal-proof__amount tk-amount">
										{formatMoney(row.amountByLocationKey[location.key])}
									</td>
								))}
								<td className="journal-proof__amount journal-proof__row-total tk-amount">{formatMoney(row.total)}</td>
							</tr>
						))}
					</tbody>
					<tfoot>
						<tr>
							<td className="journal-proof__account">Net revenue</td>
							{revenueTable.locations.map(location => (
								<td key={location.key} className="journal-proof__amount tk-amount">
									{formatMoney(revenueTable.totalByLocationKey[location.key])}
								</td>
							))}
							<td className="journal-proof__amount tk-amount">{formatMoney(revenueTable.grandTotal)}</td>
						</tr>
					</tfoot>
				</table>
				<div className="tk-note">{tableNote}</div>
			</div>
		);
	};

	render() {
		const { proof } = this.props;

		if (!proof || proof.length === 0) {
			return null;
		}

		const hasFailingRow = proof.some(row => !row.passed);

		return (
			<div className="tk-panel journal-proof">
				{this.renderHeadline()}
				{this.renderLocationTable()}
				<ToolsCollapsiblePanel title="How each figure ties" defaultOpen={hasFailingRow} hint={`Click to see all ${proof.length}`}>
					<ChecksList checks={proof} leftHeading="This journal says" rightHeading="Against" passedLabel="Ties" />
				</ToolsCollapsiblePanel>
			</div>
		);
	}
}

export default JournalProofPanel;
